import { Outlet } from 'react-router-dom';

/** Casca das telas públicas do painel (login, recuperação de senha). */
export function AuthLayout() {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-16">
        <Outlet />
      </div>

      {/* Painel de marca — decorativo, escondido no mobile. */}
      <div className="hidden bg-brand-950 lg:block" aria-hidden="true" />
    </div>
  );
}
